module.exports = __webpack_public_path__ + "static/media/Card.73af07fa.svg";